// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { Mutation } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import {
  TabbedView,
  WithdrawalBatchCard,
  ObjectCases,
  ObjectFiles,
  SvgIcon,
  Withdrawals,
  WithdrawalBatchAddEditModal as EditModal
} from '../'

import { Actions } from './Actions'
import { DeleteModal } from './DeleteModal'

import {
  MUTATION_WITHDRAWAL_BATCH,
  MUTATION_WITHDRAWAL_BATCH_DELETE
} from '../../mutations'


class WithdrawalBatchDetail extends React.PureComponent {
  static propTypes = {
    withdrawalBatch: PropTypes.object.isRequired,
    openTab: PropTypes.number.isRequired,
    className: PropTypes.string
  }

  state = {
    numberOfCases: 0,
    numberOfFiles: 0,
    edit: false,
    delete: false
  }

  toggleEditModal = () => (
    this.setState(prevState => ({ edit: !prevState.edit }))
  )

  toggleDeleteModal = () => (
    this.setState(prevState => ({ delete: !prevState.delete }))
  )

  saveChanges = (withdrawalbatchMutate, productId, initiateOn, initiateWorkflowAt) => {
    let input = {
      id: this.props.withdrawalBatch.id,
      product: productId,
      initiateOn,
      initiateWorkflowAt
     }

    withdrawalbatchMutate({ variables: { input } })
    .then(this.toggleEditModal)
    .catch(error => console.error(error))  // TODO: replace these with Sentry.captureMessage maybe?
  }

  delete = (withdrawalbatchDelete) => {
    withdrawalbatchDelete({
      variables: {
        input: {
          id: this.props.withdrawalBatch.id
        }
      }
    })
    .then(({ data }) => {
      data.withdrawalbatchDelete.outcome
        ? this.props.history.push('/os/products/withdrawalbatches')  // go to withdrawal batch listing page
        : console.error('Withdrawal batch deletion failed')
    })
    .catch(error => console.error(error))
  }

  render() {
    const { id, initiatedBy, initiateOn, initiateWorkflowAt, status, userMayUpdate, product, workflowrun } = this.props.withdrawalBatch

    return (
      <div className={`slds-size_1-of-1 ${this.props.className ? this.props.className : ''}`}>
        {/* overview section */}
        <div className='slds-p-around_large slds-border_bottom'>
          <div className='slds-grid'>
            <WithdrawalBatchCard
              initiatedByName={initiatedBy
                ? initiatedBy.fullName
                : '-'
              }
              initiateOn={initiateOn}
              initiateWorkflowAt={initiateWorkflowAt}
              status={status}
              productName={product.name}
              workflowRun={workflowrun}
              className='slds-size_1-of-2'
            />
            <Actions
              userMayUpdate={userMayUpdate}
              onEditClick={this.toggleEditModal}
              onDeleteClick={this.toggleDeleteModal}
            />
          </div>
        </div>
        {/* detail section */}
        <TabbedView
          tabs={[
            'Withdrawals',
            `Cases for this withdrawal batch${this.state.numberOfCases > 0 ? ` (${this.state.numberOfCases})` : ''}`,
            `Files${this.state.numberOfCases > 0 ? ` (${this.state.numberOfFiles})` : ''}`,
          ]}
          contents={[
            <Withdrawals withdrawalBatchId={id} status='' search='' />,
            <ObjectCases object={id} pageBasedPagination={true} />,
            <ObjectFiles
              object={id}
              noRecordsToDisplay={
                <div className='slds-m-left_large'>
                  <SvgIcon
                    variant='utility'
                    symbol='info'
                    colour='light'
                    size='small'
                    className='slds-m-right_x-small'
                  />
                  No related items found
                </div>
              }
            />
          ]}
          tabSpacing='x-large'
          selectedTab={this.props.openTab}
          onClick={this.props.onTabClick}
          tabsClassName='slds-p-left_large slds-p-bottom_small slds-p-right_large'
        />
        {this.state.edit &&
          <Mutation mutation={MUTATION_WITHDRAWAL_BATCH}>
            {withdrawalbatchMutate => (
              <EditModal
                product={product.id}
                initiateOn={initiateOn}
                initiateWorkflowAt={initiateWorkflowAt}
                onCancelClick={this.toggleEditModal}
                onSaveClick={(productId, initiateOn, initiateWorkflowAt) => {
                  this.saveChanges(withdrawalbatchMutate, productId, initiateOn, initiateWorkflowAt)
                }}
              />
            )}
          </Mutation>
        }
        {this.state.delete &&
          <Mutation mutation={MUTATION_WITHDRAWAL_BATCH_DELETE}>
            {withdrawalbatchDelete => (
              <DeleteModal
                onCancelClick={this.toggleDeleteModal}
                onConfirmClick={() => this.delete(withdrawalbatchDelete)}
              />
            )}
          </Mutation>
        }
      </div>
    )
  }
}

export default withRouter(WithdrawalBatchDetail)



// WEBPACK FOOTER //
// ./src/components/withdrawal-batch-detail/index.js